<template>
  <div>
    <v-container grid-list-xs fill-height>
      <v-layout justify-center align-center>
        <v-flex xs12 sm10 md9>
          <Calculator @calculate="calculate" />
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="title">Result</v-card-title>
        <v-divider></v-divider>
        <v-card-text
          class="headline justify-center d-flex"
        >m = 0.5659({{ x }}) - 0.7454 = {{ result }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Calculator from "../components/Calculator.vue";

export default {
  components: {
    Calculator
  },
  data: () => ({
    dialog: false,
    x: 0,
    result: 0
  }),
  methods: {
    calculate(x) {
      this.dialog = true;
      let result = 0.5659 * x - 0.7454;
      this.x = x;
      this.result = result;
    }
  }
};
</script>
